<template>
  <div class="mb-3 text-start">
    <div class="input-group-text mb-1">Accesorii</div>
    <ul v-if="modelValue.length" class="list-group mb-1">
      <li v-for="accesoriu in modelValue" :key="accesoriu.id" class="list-group-item d-flex align-items-center justify-content-between">
        <span>{{ eticheta(accesoriu) }}</span>
        <button v-if="!readonly" class="btn btn-sm btn-danger ms-2" type="button" :disabled="disabled" @click="elimina(accesoriu.id)">Detașează</button>
      </li>
    </ul>
    <p v-else class="mb-1">Fără accesorii atașate.</p>
    <FSearchSelect
      v-if="!readonly"
      :options="disponibile"
      :favorite-ids="favoriteIds"
      include-subtip
      utilaj="Adaugă accesoriu"
      :disabled="disabled"
      @utilaj_selectat="adauga"
    />
  </div>
</template>

<script>
import FSearchSelect from './FSearchSelect.vue';

export default {
  name: 'AccesoriiSelect',
  components: { FSearchSelect },
  props: {
    modelValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    favoriteIds: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue', 'selecteaza-accesoriu'],
  computed: {
    disponibile() {
      const ids = new Set(this.modelValue.map(item => String(item.id)));
      return this.options.filter(item => !ids.has(String(item.id)));
    },
  },
  methods: {
    eticheta(item) {
      return [item.inventar, item.subtip, item.producator, item.model].filter(Boolean).join(' - ');
    },
    adauga(item) {
      if (this.disabled || this.readonly || this.modelValue.some(selected => String(selected.id) === String(item.id))) return;
      this.$emit('selecteaza-accesoriu', item);
    },
    elimina(id) {
      if (this.disabled || this.readonly) return;
      this.$emit('update:modelValue', this.modelValue.filter(item => String(item.id) !== String(id)));
    },
  },
};
</script>
